import React, {
  useRef,
  useState,
  useEffect
} from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';

export const AgregarProfesion = (props) => {
  var op = require('../../../../../../src/modulos/datos');
  let token = localStorage.getItem('jwtToken');

  // Refs para los campos según el orden del Java
  const cmbGradoInstruccion = useRef(null);
  const cmbEspecialidad = useRef(null);
  const cmbMencion = useRef(null);

  // Estado para el modo de operación
  const [operacion, setOperacion] = useState(props.operacion);

  // Estados para las listas de valores
  const [gradosInstruccion, setGradosInstruccion] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [menciones, setMenciones] = useState([]);

  // Estado para controlar validaciones
  const [errores, setErrores] = useState({});

  // IDs seleccionados
  const [idGrado, setIdGrado] = useState(null);
  const [idEspecialidad, setIdEspecialidad] = useState(null);
  const [idMencion, setIdMencion] = useState(null);

  // Estado de carga
  const [cargando, setCargando] = useState(false);

  // ============================================
  // FUNCIÓN CORREGIDA: Seleccionar Menciones por Especialidad
  // ============================================
  const seleccionarMencion = (idEspecialidad) => {
    if (!idEspecialidad) {
      setMenciones([]);
      return;
    }

    let campos = "mencion.idmencion, mencion.descripcion";
    let nomtab = "mencion , especialidad";
    let condi = `mencion.idespecialidad = especialidad.idespecialidad and mencion.idespecialidad = ${idEspecialidad}`;
    let orden = "mencion.descripcion";
    
    // CORRECCIÓN: Codificar los parámetros para URL
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&condi=${encodeURIComponent(condi)}&orden=${encodeURIComponent(orden)}`;

    setCargando(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data) {
          // CORRECCIÓN: Mapear correctamente los datos
          const mencionesData = response.data.map(item => ({
            id: item.idmencion,
            descripcion: item.descripcion
          }));
          setMenciones(mencionesData);
        }
      })
      .catch(error => {
        console.error("Error cargando menciones:", error);
      })
      .finally(() => setCargando(false));
  };

  // ============================================
  // FUNCIÓN CORREGIDA: Seleccionar Especialidades por Grado
  // ============================================
  const seleccionarEspecialidad = (idGrado) => {
    if (!idGrado) {
      setEspecialidades([]);
      return;
    }

    let campos = "especialidad.descripcion, especialidad.idespecialidad";
    let nomtab = "especialidad , gradoinstruccion";
    let condi = `especialidad.idgradoinstruccion = gradoinstruccion.idgradoinstruccion and especialidad.idgradoinstruccion = ${idGrado}`;
    let orden = "especialidad.descripcion";
    
    // CORRECCIÓN: Codificar los parámetros para URL
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&condi=${encodeURIComponent(condi)}&orden=${encodeURIComponent(orden)}`;

    setCargando(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data) {
          // CORRECCIÓN: Mapear correctamente los datos
          const especialidadesData = response.data.map(item => ({
            id: item.idespecialidad,
            descripcion: item.descripcion
          }));
          setEspecialidades(especialidadesData);
        }
      })
      .catch(error => {
        console.error("Error cargando especialidades:", error);
      })
      .finally(() => setCargando(false));
  };

  // Seleccionar Grados de Instrucción (igual que en Java)
  const seleccionarGradosInstruccion = () => {
    const campos = "*";
    const nomtab = "gradoinstruccion";
    const orden = "idgradoinstruccion";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setCargando(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data) {
          const grados = response.data.map(item => ({
            id: item.idgradoinstruccion,
            descripcion: item.descripcion
          }));
          setGradosInstruccion(grados);
        }
      })
      .catch(error => {
        console.error("Error cargando grados:", error);
      })
      .finally(() => setCargando(false));
  };

  // Cargar datos iniciales al abrir el modal
  useEffect(() => {
    if (props.show) {
      seleccionarGradosInstruccion();
      // Limpiar selecciones
      setIdGrado(null);
      setIdEspecialidad(null);
      setIdMencion(null);
    }
  }, [props.show]);

  // Cuando cambia el grado, cargar especialidades
  useEffect(() => {
    if (idGrado) {
      seleccionarEspecialidad(idGrado);
    } else {
      setEspecialidades([]);
    }
    
    // Limpiar especialidad y mención seleccionadas
    if (cmbEspecialidad.current) cmbEspecialidad.current.value = '';
    if (cmbMencion.current) cmbMencion.current.value = '';
    setIdEspecialidad(null);
    setIdMencion(null);
  }, [idGrado]);

  // Cuando cambia la especialidad, cargar menciones
  useEffect(() => {
    if (idEspecialidad) {
      seleccionarMencion(idEspecialidad);
    } else {
      setMenciones([]);
    }
    
    // Limpiar mención seleccionada
    if (cmbMencion.current) cmbMencion.current.value = '';
    setIdMencion(null);
  }, [idEspecialidad]);

  // Validar campos (como en Java)
  const validarCampos = () => {
    const nuevosErrores = {};
    let valido = true;

    if (!idGrado) {
      nuevosErrores.grado = "Debe seleccionar el grado de instrucción";
      valido = false;
    }

    if (!idEspecialidad) {
      nuevosErrores.especialidad = "Debe seleccionar la especialidad";
      valido = false;
    }

    if (!idMencion) {
      nuevosErrores.mencion = "Debe seleccionar la mención";
      valido = false;
    }

    setErrores(nuevosErrores);
    return valido;
  };

  // Función para aceptar (como en Java)
  const aceptar = () => {
    if (operacion === 1 || operacion === 2) {
      if (!validarCampos()) {
        return;
      }
    }

    // Obtener los textos seleccionados para mostrar
    const gradoText = cmbGradoInstruccion.current?.options[cmbGradoInstruccion.current.selectedIndex]?.text || '';
    const especialidadText = cmbEspecialidad.current?.options[cmbEspecialidad.current.selectedIndex]?.text || '';
    const mencionText = cmbMencion.current?.options[cmbMencion.current.selectedIndex]?.text || '';

    // Construir objeto con los datos en el mismo orden que Java
    const datosProfesion = {
      idmencion: idMencion,                    // ID de la mención (índice 0 en datret)
      gradoinstruccion: gradoText.toUpperCase(), // Grado (índice 1 en datret)
      especialidad: especialidadText.toUpperCase(), // Especialidad (índice 2 en datret)
      descripcion: mencionText.toUpperCase()    // Mención (índice 3 en datret)
    };

    console.log('Datos de la profesión a enviar:', datosProfesion);

    // Devolver los datos al componente padre
    if (props.onAceptar) {
      props.onAceptar(datosProfesion);
    }

    props.onHide();
  };

  const cancelar = () => {
    // Limpiar selecciones
    if (cmbGradoInstruccion.current) cmbGradoInstruccion.current.value = '';
    if (cmbEspecialidad.current) cmbEspecialidad.current.value = '';
    if (cmbMencion.current) cmbMencion.current.value = '';
    setIdGrado(null);
    setIdEspecialidad(null);
    setIdMencion(null);

    props.onHide();
  };

  const deshabilitarCampos = () => {
    const campos = [cmbGradoInstruccion, cmbEspecialidad, cmbMencion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = true;
    });
  };

  const habilitarCampos = () => {
    const campos = [cmbGradoInstruccion, cmbEspecialidad, cmbMencion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = false;
    });
  };

  // Efecto para manejar cambios en props
  useEffect(() => {
    setOperacion(props.operacion);

    if (props.show) {
      if (props.operacion === 1) {
        // Modo incluir: habilitar campos y limpiar
        setTimeout(() => {
          habilitarCampos();
          if (cmbGradoInstruccion.current) {
            cmbGradoInstruccion.current.value = '';
            cmbGradoInstruccion.current.focus();
          }
          if (cmbEspecialidad.current) cmbEspecialidad.current.value = '';
          if (cmbMencion.current) cmbMencion.current.value = '';
          setIdGrado(null);
          setIdEspecialidad(null);
          setIdMencion(null);
        }, 100);
      } else if (props.operacion === 4) {
        // Modo consulta: deshabilitar campos
        setTimeout(() => {
          deshabilitarCampos();
        }, 100);
      } else if (props.operacion === 2 && props.datos) {
        // Modo edición: habilitar campos y cargar datos
        setTimeout(() => {
          habilitarCampos();
          
          // Aquí deberías cargar los datos para edición
          // Por ejemplo, si tienes los IDs en props.datos:
          if (props.datos.idmencion) {
            // Buscar y seleccionar el grado, especialidad y mención correspondientes
            // Esto requeriría lógica adicional para seleccionar los valores correctos
            setIdMencion(props.datos.idmencion);
          }
        }, 100);
      }
    }
  }, [props.operacion, props.show, props.datos]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 1 && "Incluir Profesión"}
          {operacion === 2 && "Editar Profesión"}
          {operacion === 4 && "Consultar Profesión"}
        </h3>
        <a type="button" onClick={cancelar} style={{ cursor: 'pointer' }}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center">
          <legend className="float-none m-0 w-auto">Datos de la Profesión</legend>

          {/* Mostrar errores de validación */}
          {Object.keys(errores).length > 0 && (
            <div className="alert alert-danger col-12" role="alert">
              {Object.values(errores).map((error, index) => (
                <div key={index}>• {error}</div>
              ))}
            </div>
          )}

          {/* Indicador de carga */}
          {cargando && (
            <div className="text-center col-12 mb-2">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          )}

          <div className="col-md-12 px-0 mx-auto row">
            {/* Grado de Instrucción - Primer campo */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '150px' }}>Grado de Instrucción:</span>
              <select
                className="form-select"
                ref={cmbGradoInstruccion}
                disabled={operacion === 4 || operacion === 3}
                value={idGrado || ''}
                onChange={(e) => {
                  const selectedId = e.target.value ? parseInt(e.target.value) : null;
                  setIdGrado(selectedId);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && cmbEspecialidad.current) {
                    cmbEspecialidad.current.focus();
                  }
                }}
              >
                <option value="">Seleccione...</option>
                {gradosInstruccion.map(grado => (
                  <option key={grado.id} value={grado.id}>
                    {grado.descripcion}
                  </option>
                ))}
              </select>
            </div>

            {/* Especialidad - Segundo campo */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '150px' }}>Especialidad:</span>
              <select
                className="form-select"
                ref={cmbEspecialidad}
                disabled={operacion === 4 || operacion === 3 || !idGrado}
                value={idEspecialidad || ''}
                onChange={(e) => {
                  const selectedId = e.target.value ? parseInt(e.target.value) : null;
                  setIdEspecialidad(selectedId);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && cmbMencion.current) {
                    cmbMencion.current.focus();
                  }
                }}
              >
                <option value="">Seleccione...</option>
                {especialidades.map(esp => (
                  <option key={esp.id} value={esp.id}>
                    {esp.descripcion}
                  </option>
                ))}
              </select>
            </div>

            {/* Mención - Tercer campo */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '150px' }}>Mención:</span>
              <select
                className="form-select"
                ref={cmbMencion}
                disabled={operacion === 4 || operacion === 3 || !idEspecialidad}
                value={idMencion || ''}
                onChange={(e) => {
                  const selectedId = e.target.value ? parseInt(e.target.value) : null;
                  setIdMencion(selectedId);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    aceptar();
                  }
                }}
              >
                <option value="">Seleccione...</option>
                {menciones.map(men => (
                  <option key={men.id} value={men.id}>
                    {men.descripcion}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {(operacion === 1 || operacion === 2) && (
          <button
            type="button"
            className="btn btn-sm rounded-pill col-md-2 btn-success"
            onClick={aceptar}
          >
            Aceptar
          </button>
        )}
        <button
          type="button"
          onClick={cancelar}
          className="btn btn-sm rounded-pill col-md-2 btn-danger"
        >
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};